import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'internDetail',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    isSignedIn () {
      return this.$store.getters.isSignedIn
    },
    env () {
      return this.$store.getters.env
    },
    api () {
      return this.$store.getters.api
    },
    user () {
      return this.$store.getters.user
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      student: {},
      intern: {},
      loading: true,
      updating: false,
      error: {
        flag: false,
        message: ''
      },
      tab: '1',
      isApplied: false,
      fields: [
        { key: 'time', label: '', class: 'text-primary font-weight-bold' },
        { key: 'mon', label: '月' },
        { key: 'tue', label: '火' },
        { key: 'wed', label: '水' },
        { key: 'tus', label: '木' },
        { key: 'fri', label: '金' },
        { key: 'sat', label: '土' },
        { key: 'sun', label: '日' }
      ],
      items: [
        { time: { label: '9:00 〜 12:00', value: 1 } },
        { time: { label: '12:00 〜 15:00', value: 2 } },
        { time: { label: '15:00 〜 18:00', value: 3 } },
        { time: { label: '18:00 〜 21:00', value: 4 } }
      ]
    }
  },
  mounted () {
    this.onInit()
  },
  methods: {
    onInit () {
      this.loading = true

      let pathParams = {
        internId: this.$route.params.internId
      }

      let additionalParams = {
        queryParams: {
          type: 'detail'
        }
      }

      this.$apig.get(this.api.INTERN, pathParams, additionalParams, {}, !this.isSignedIn)
        .then(response => {
          this.intern = response.data.intern
          this.student = response.data.student
          this.loading = false
        })
    },
    getAvatar (avatarId) {
      return `${process.env.S3}/student/avatar/${avatarId}.png`
    },
    addLike () {
      this.updating = true

      let pathParams = {
        internId: this.$route.params.internId
      }

      let additionalParams = {
        queryParams: {
          type: !this.intern.isLike ? 'like' : 'dislike'
        }
      }

      this.$apig.patch(this.api.INTERN, pathParams, additionalParams, {})
        .then(response => {
          this.loading = true
          this.onInit()
          this.updating = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/intern/detail/detail.js